import Image from 'next/image';

import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';

const HERO_BACKGROUND_IMAGE = '/images/about-us/hero-background.jpg';
const HERO_BACKGROUND_IMAGE_MOBILE = '/images/about-us/hero-background-mobile.png';
const HERO_SUBTITLE =
  "Udacity is the trusted market leader in talent transformation. We change lives, businesses, and nations through digital upskilling, developing the edge you need to conquer what's next.";

export function HeroSection() {
  return (
    <Box as='section' bg='#0A0B0F' overflow='hidden' position='relative' width='full'>
      <Box display={{ base: 'block', md: 'none' }} inset={0} position='absolute'>
        <Image
          alt=''
          quality={100}
          sizes='100vw'
          src={HERO_BACKGROUND_IMAGE_MOBILE}
          style={{ objectFit: 'cover', objectPosition: 'top center' }}
          fill
          priority
        />
      </Box>
      <Box display={{ base: 'none', md: 'block' }} inset={0} position='absolute'>
        <Image
          alt=''
          quality={100}
          sizes='100vw'
          src={HERO_BACKGROUND_IMAGE}
          style={{ objectFit: 'cover', objectPosition: 'center center' }}
          fill
        />
        <Box
          bgGradient='linear(to right, rgba(10,11,15,0.85) 0%, rgba(10,11,15,0.55) 35%, rgba(10,11,15,0) 65%)'
          inset={0}
          position='absolute'
        />
      </Box>

      <ContentContainer
        alignItems={{ base: 'flex-end', md: 'center' }}
        display='flex'
        minHeight={{ base: '32rem', md: '40rem' }}
        position='relative'
      >
        <Flex
          flexDirection='column'
          gap={6}
          maxWidth={{ base: 'full', md: '34.625rem' }}
          pb={{ base: 6, md: 0 }}
          zIndex={1}
        >
          <Heading
            as='h1'
            color='white'
            fontFamily='heading'
            fontSize={{ base: '2.5rem', md: '4.75rem' }}
            fontWeight={500}
            letterSpacing='-0.03em'
            lineHeight={{ base: '1.05', md: '1' }}
          >
            We turn talent
            <br />
            into greatness.
          </Heading>
          <Text as='p' color='#F2F2F2' fontFamily='body' fontSize='1.125rem' lineHeight='1.5' maxWidth='34.625rem'>
            {HERO_SUBTITLE}
          </Text>
        </Flex>
      </ContentContainer>
    </Box>
  );
}
